import { render, staticRenderFns } from "./queueOrder.vue?vue&type=template&id=fde3ec4c&scoped=true&"
import script from "./queueOrder.vue?vue&type=script&lang=js&"
export * from "./queueOrder.vue?vue&type=script&lang=js&"
import style0 from "./queueOrder.vue?vue&type=style&index=0&id=fde3ec4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde3ec4c",
  null
  
)

export default component.exports